import { useEffect, useState } from "react";
import { useSetRecoilState, useRecoilState } from "recoil";
import { helpTargetState, helpContentState } from "../recoil";
import helpContentFile from "../datas/helpExample.json";

interface MouseTrackerProps {
  children: React.ReactNode;
}

export default function MouseTracker({ children }: MouseTrackerProps) {
  const setHelpTarget = useSetRecoilState(helpTargetState);
  const [helpContent, setHelpContent] = useRecoilState(helpContentState);
  const [hoverTimer, setHoverTimer] = useState<number | null>(null);

  useEffect(() => {
    const handleMouseOver = (event: MouseEvent) => {
      const basicIdList = ["root"];
      const target = event.target as HTMLElement;

      const parentsWithId = target.closest("[id]");

      if (
        !parentsWithId ||
        !parentsWithId.id ||
        basicIdList.includes(parentsWithId.id)
      ) {
        return;
      }

      const targetId = parentsWithId.id;

      const timerId = window.setTimeout(() => {
        if (targetId === "help-box") {
          return;
        }

        setHelpTarget(targetId);
        const helpText =
          (helpContentFile as HelpContent)[targetId] || targetId.toString();
        setHelpContent(helpText);
      }, 3000);

      setHoverTimer(timerId);
    };

    const handleMouseLeave = () => {
      if (hoverTimer) {
        clearTimeout(hoverTimer);
        setHoverTimer(null);
      }
    };

    window.addEventListener("mouseover", handleMouseOver, true);
    window.addEventListener("mouseleave", handleMouseLeave, true);

    return () => {
      window.removeEventListener("mouseover", handleMouseOver, true);
      window.removeEventListener("mouseleave", handleMouseLeave, true);
      if (hoverTimer) {
        clearTimeout(hoverTimer);
      }
    };
  }, [setHelpTarget, setHelpContent, hoverTimer]);

  return <div>{children}</div>;
}
